<script setup lang="ts">
const props = defineProps({
  label: {
    type: String,
    required: true,
  },

  colorName: {
    type: String,
    required: true,
  },

  minWidth: {
    type: String,
    default: "0",
  },

  maxWidth: {
    type: String,
    default: "100%",
  },

  valueIsLessThanIndex: {
    type: Boolean,
    default: false,
  },
});

const _value = defineModel<number>({ required: true });

const _valueLessThanIndex = computed({
  get: () => {
    if (props.valueIsLessThanIndex) {
      return _value.value - 1;
    }
    return _value.value;
  },
  set: (v) => (_value.value = v),
});
</script>

<template>
  <div :class="$style.container">
    <div :class="$style.background">
      <SegmentedBar :activeSegments="_valueLessThanIndex" size="input" :colorName="colorName" />
    </div>

    <div :class="$style.slot">
      <DropDown
        v-model="_value"
        :label="label"
        colorBackground="--color-transparent"
        :colorForeground="`--color-${colorName}-300`"
        minWidth="12rem"
        maxWidth="12rem"
      >
        <slot />
      </DropDown>
    </div>
  </div>
</template>

<style module>
.container,
.background,
.slot {
  display: flex;
  flex-direction: column;
}

.container {
  position: relative;
}

.background {
  position: absolute;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
}
</style>
